<template>
  <v-card
    v-if="showCard"
    id="import-modal-processing-card"
    class="pb-1"
    :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
  >
    <v-card-title>
      {{ $t(`views.imports.importModal.importModalProcessingCard.title`) }}
    </v-card-title>

    <v-card-text class="py-0 mb-0 mt-2">
      <div class="text-center mt-8 mb-5">
        <v-progress-circular
          size="40"
          width="3"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <p class="pt-2 pb-8" :class="{ 'white--text': $vuetify.theme.dark }">
        {{ $t(`views.imports.importModal.importModalProcessingCard.description1`) }}
        <br />
        {{ $t(`views.imports.importModal.importModalProcessingCard.description2`) }}
      </p>
    </v-card-text>
    <!-- <v-card-actions>
      <v-spacer />
      <v-btn class="mr-1" text :small="$vuetify.breakpoint.smAndDown" @click="$emit('close')">
        {{ $t('common.close') }}
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<script>
import { get } from 'lodash'
import { getImport } from '@/lib/api'

export default {
  props: {
    myImport: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadTimeout: null,
      lastStatus: null,
    }
  },
  computed: {
    showCard() {
      // return true
      return this.lastStatus === 'pending' || this.lastStatus === 'processing'
    },
  },
  watch: {
    'myImport.status'() {
      this.lastStatus = get(this.myImport, 'status', null)
      if (this.lastStatus === 'pending' || this.lastStatus === 'processing') {
        this.createTimeout()
      } else {
        clearTimeout(this.loadTimeout)
      }
    },
  },
  destroyed() {
    clearTimeout(this.loadTimeout)
  },
  methods: {
    createTimeout() {
      clearTimeout(this.loadTimeout)
      this.loadTimeout = setTimeout(() => {
        this.getImportAndCheckStatus()
      }, 5000)
    },
    async getImportAndCheckStatus() {
      const result = await getImport(this.myImport._id)
      const myImport = result.data

      if (myImport.status === this.lastStatus) this.createTimeout()
      else this.$emit('update:myImport', myImport)
    },
  },
}
</script>

<style lang="scss">
#import-modal-processing-card {
  p {
    font-size: 15px;
    text-align: center;
  }
}
</style>
